import {secured as axios} from "../../../axios";

export class Profile {
    static linkAccountUri = '/link/account';
    static unlinkAccountUri = '/unlink/account';
    static switchAccountUri = '/switch-account';

    static async linkAccount(mail,type) {
        return await axios.post(`${this.linkAccountUri}`, {
            email: mail,
            type: type,
        }).then((res) => {
            return res;
        });
    }

    static async unlinkAccount(mail) {
        const res = await axios.post(`${this.unlinkAccountUri}`, {
            email: mail
        })
        return res.status;
    }

    static async switchAccount(mail) {
        const res = await axios.post(`${this.switchAccountUri}`, {
            email: mail
        })
        return res.data;
    }

    static async getSurroundings() {
        const res = await axios.get('/children-associated/account');
        //const res = await axios.get('/parent-associated/account');
        return res.data;
    }

    static async getGodFather() {
        //const res = await axios.get('/children-associated/account');
        const res = await axios.get('/parent-associated/account');
        return res.data;
    }

    static async updatePassword(actualPass, newPass) {
        return await axios.patch('/user-password', {
               currentPassword: actualPass,
               newPassword: newPass
        }); //TO DO Catch error
    }

    static async updateInformation(data) {
        console.log(data);
        const jsonData = {
            ...(data.firstName ? {firstName: data.firstName} : {}),
            ...(data.lastName ? {lastName: data.lastName} : {}),
            ...(data.mail ? {email: data.mail} : {}),
            ...(data.profileImage ? {profile: data.profileImage} : {}),
            ...(data.postalCode ? {postalCode: data.postalCode} : {}),
            ...(data.address ? {address: data.address} : {}),
            ...(data.phonenumber ? {phoneNumber: data.phonenumber} : {phoneNumber : ''}),
            ...(data.birthday ? {birthDate: data.birthday} : {}),
            ...(data.city ? {city: data.city} : {}),
            ...(data.countryCode ? {countryCode: data.countryCode} : {}),
        };

        if (data.image) {
            const [_, ext] = data.image.split(';')[0].split('/');
            console.log(ext);
            if (ext !== "") {
                jsonData['profile'] = {base64: data.image, name: `profile.${ext}`};
            }
        }
        console.log(jsonData);
        const res = await axios.patch('/user', jsonData)
    }
}
